<base-modal-component class="base-modal">
    <img src="{{src}}" style="width: 100%;" class="{{rotated ? 'img-rotated' : ''}}"/>
</base-modal-component>
